import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { ReloadIcon } from "../../../../styles/img/svg/ReloadIcon";
import { ReloadIconDark } from "../../../../styles/img/svg/ReloadIconDark";

const useStylesForSpinner = makeStyles((theme) => ({
  root: {
    position: "relative",
    color: "red",
  },

  top: {
    color: "#1a90ff",
    animationDuration: "550ms",
    left: 0,
  },
  circle: {
    strokeLinecap: "round",
    background: "red",
    color: "#231F20",
  },
}));

export const UiBackdropLoader = (props) => {
  const classes = useStylesForSpinner();

  return (
    <>
      <div className="df-backdrop-loader">
        {props.inverted ? (
          <div className="df-inverted">
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={props.loaderSize}
              thickness={props.loaderThickness}
            />
            {props.backdropMessage && (
              <p className="df-backdrop-loader__message">
                {props.backdropMessage}
              </p>
            )}
          </div>
        ) : (
          <CircularProgress
            variant="indeterminate"
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={props.loaderSize}
            thickness={props.loaderThickness}
          />
        )}
      </div>
    </>
  );
};

export const UiLoginLoader = (props) => {
  const classes = useStylesForSpinner();

  return (
    <>
      <div className="df-login-full-loader">
        {props.inverted ? (
          <div className="df-inverted">
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={props.loaderSize}
              thickness={props.loaderThickness}
            />
            {props.backdropMessage && (
              <p className="df-login-full-loader__message">
                {props.backdropMessage}
              </p>
            )}
          </div>
        ) : (
          <CircularProgress
            variant="indeterminate"
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={props.loaderSize}
            thickness={props.loaderThickness}
          />
        )}
      </div>
    </>
  );
};

export const UiGrayBgLoader = (props) => {
  const classes = useStylesForSpinner();
  const bgLoaderClass = `df-whitecard-loader ${
    props.className && props.className
  }`;

  return (
    <>
      <div className={bgLoaderClass}>
        {props.inverted ? (
          <div className="df-inverted">
            <CircularProgress
              variant="indeterminate"
              className={classes.top}
              classes={{
                circle: classes.circle,
              }}
              size={props.loaderSize}
              thickness={props.loaderThickness}
            />
          </div>
        ) : (
          <CircularProgress
            variant="indeterminate"
            className={classes.top}
            classes={{
              circle: classes.circle,
            }}
            size={props.loaderSize}
            thickness={props.loaderThickness}
          />
        )}
      </div>
    </>
  );
};

export const UiGrayBgLoaderWithMessage = (props) => {
  const bgLoaderwithMsgClass = `df-whitecard-loader ${
    props.className && props.className
  }`;

  return (
    <>
      <div className={bgLoaderwithMsgClass}>
        <div className="df-wc-message">
          {props.icon}
          <p>{props.errorMessage}</p>
        </div>
      </div>
    </>
  );
};
